import { useState } from "react";
import { Search, ArrowRight, Building2, Loader2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const LoginSchoolDialog = ({ open, onOpenChange }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const slug = name.trim().toLowerCase().replace(/[^a-z0-9-]/g, "");
  const target = `https://${slug || "namasekolah"}.sahabatpena.id`;

  const handleGo = () => {
    if (!slug) {
      toast.error("Ketik nama/subdomain sekolah Anda terlebih dahulu.");
      return;
    }
    setLoading(true);
    // Di produksi (VPS): arahkan ke subdomain sekolah.
    // Di preview ini, subdomain wildcard belum aktif, jadi kita tampilkan tujuan.
    setTimeout(() => {
      setLoading(false);
      toast.success(`Mengarahkan ke ${target}/login`, {
        description: "Di lingkungan produksi (VPS), Anda akan langsung masuk ke portal sekolah ini.",
      });
    }, 700);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="border-cyan-500/20 bg-[#0D1424] text-white sm:max-w-md" data-testid="login-dialog">
        <DialogHeader>
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-cyan-400/20 to-violet-600/20 text-cyan-400">
            <Building2 className="h-5 w-5" />
          </div>
          <DialogTitle className="font-heading text-xl">Login ke Sekolah Saya</DialogTitle>
          <DialogDescription className="text-slate-400">
            Ketik nama subdomain sekolah Anda untuk masuk ke portal masing-masing.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-2 space-y-4">
          <div>
            <div className="flex items-center gap-2 rounded-lg border border-cyan-500/20 bg-slate-900/60 px-3 py-1 focus-within:border-cyan-400/60">
              <Search className="h-4 w-4 flex-shrink-0 text-slate-500" />
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleGo()}
                placeholder="cth: sman1jakarta"
                data-testid="login-subdomain-input"
                className="border-0 bg-transparent px-0 text-white focus-visible:ring-0 focus-visible:ring-offset-0"
              />
            </div>
            <p className="mt-2 font-mono text-xs text-slate-500" data-testid="login-preview-url">
              → {target}/login
            </p>
          </div>

          <Button
            onClick={handleGo}
            disabled={loading}
            data-testid="login-go-btn"
            className="h-11 w-full bg-gradient-to-r from-cyan-400 to-violet-600 font-semibold text-[#060A12] hover:shadow-[0_0_20px_rgba(0,240,255,0.4)]"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <>Masuk Portal Sekolah <ArrowRight className="ml-1 h-4 w-4" /></>}
          </Button>

          <p className="text-center text-xs text-slate-500">
            Belum punya portal sekolah? Daftar dan dapatkan subdomain gratis.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
